import React, { useState } from 'react';

export default function AdBanner() {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;

  const dismiss = () => setDismissed(true);
  const open = () => alert('Opening Devotional Music...');

  return (
    <>
      {/* Desktop: tall story-card */}
      <div className="ad-desk">
        <div className="ad-desk-visual">
          <div className="ad-desk-ring">
            <span className="ad-desk-emoji">🕉️</span>
          </div>
          <div className="ad-desk-visual-text">Divine Music</div>
        </div>
        <div className="ad-desk-body">
          <div className="ad-desk-meta">
            <span className="ad-desk-label">Sponsored</span>
            <button className="ad-desk-close" onClick={dismiss} aria-label="Dismiss">✕</button>
          </div>
          <div className="ad-desk-title">Find Peace in Every Note</div>
          <div className="ad-desk-sub">1,000+ Bhajans, Mantras &amp; Spiritual Melodies — free</div>
          <button className="ad-desk-cta" onClick={open}>🎵 Listen Now</button>
        </div>
      </div>

      {/* Mobile: compact horizontal strip */}
      <div className="ad-mob">
        <div className="ad-mob-icon">🕉️</div>
        <div className="ad-mob-text">
          <div className="ad-mob-title">Divine Devotional Music</div>
          <div className="ad-mob-sub">1000+ Bhajans · Free</div>
        </div>
        <button className="ad-mob-cta" onClick={open}>Listen</button>
        <button className="ad-mob-close" onClick={dismiss} aria-label="Dismiss">✕</button>
      </div>
    </>
  );
}
